import React from 'react'
import { Modal, Select } from 'antd'
import styled from 'styled-components'
import Button from 'components/Button/index'

const { Option } = Select

const CustomArrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: '#A0A0A0' }}
  >
    <path d="M0 0L5 5L10 0" fill="currentColor" />
  </svg>
)

const CenteredImage = styled.img`
  display: block;
  margin: 0 auto;
`

const Title = styled.div`
  font-size: 20px;
  text-align: center;
  font-weight: 500;
  margin-top: 16px;
`
const SubtitleRow = styled.div`
  font-size: 14px;
  text-align: center;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  .ant-select {
    min-width: 180px;
    .ant-select-selector {
      border-radius: 10px;
      border: 1px solid #D6DBF7;
      background-color: #ffffff;
      min-width: 180px;
      text-align: center;
    }
    .ant-select-selection-item {
      font-weight: 700 !important;
      color: #000000;
    }
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
`

const CustomModal = ({
  isOpen,
  onClose,
  onConfirm,
  iconSrc,
  candidatesCount = 0,
  rounds = [],
  selectedRound ,
  onRoundChange,
  width = 800,
  ButtonWidth = '80px',
  ButtonHeight = '38px',
  ButtonBorderRadius = '8px',
  height = 'auto',
  modalStyle = {},
  titleStyle = {},
  subtitleStyle = {},
  imageWidth = 94,
  imageHeight = 119,
  yesText = 'Yes',
  noText = 'No',
  titleText = '',
  subTitleText = '',
  customContent = null,
  disableConfirm = false,
}) => {
  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      width={width}
      style={{ minWidth: width, maxWidth: 'none' }}
      onCancel={onClose}
      bodyStyle={{ height, ...modalStyle }}
    >
      {iconSrc && (
        <CenteredImage
          src={iconSrc}
          alt="modal-icon"
          style={{ width: imageWidth, height: imageHeight }}
        />
      )}

      {titleText && (
        <Title style={titleStyle}>
          {titleText.replace('{count}', candidatesCount)}
        </Title>
      )}

      {customContent ? (
        customContent
      ) : (
        subTitleText && rounds.length > 0 && (
          <SubtitleRow style={subtitleStyle}>
            {subTitleText}
            <Select
              value={selectedRound}
              onChange={value => onRoundChange(value)}
              suffixIcon={<CustomArrow />}
              dropdownRender={menu => (
                <div
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '8px',
                    padding: '8px',
                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)'
                  }}
                >
                  {menu}
                </div>
              )}
              style={{
                fontWeight: 600  // Make selected value bold
              }}
              optionLabelProp="label"
            >
              {rounds.map(round => {
                return (
                  <Option
                    key={round.value}
                    value={round.value}
                    label={round.name}
                    style={{
                      color: '#000000',
                      fontWeight:400,
                      padding: '8px 12px'
                    }}
                  >
                    {round.name}
                  </Option>
                )
              })}
            </Select>
          </SubtitleRow>
        )
      )}

      <Footer>
        <Button.Secondary
          text={noText}
          width={ButtonWidth}
          height={ButtonHeight}
          onClick={onClose}
          style={{
            borderRadius: `${ButtonBorderRadius}`,
            fontSize: '14px',
            fontWeight: 600
          }}
        />
        <Button.Primary
          text={yesText}
          width={ButtonWidth}
          height={ButtonHeight}
          onClick={onConfirm}
          disabled={disableConfirm}
          style={{
            borderRadius: `${ButtonBorderRadius}`,
            fontSize: '14px',
            fontWeight: 600
          }}
        />
      </Footer>
    </Modal>
  )
}

export default CustomModal
